module.exports = __webpack_public_path__ + "img/eventyr_logo.979b136c.png";